// @mui
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// routes
import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';
// _mock
import { _socials } from 'src/_mock';
// components
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { IVORYPhotoStudioAr, IVORYPhotoStudioEn } from 'src/constants/companyinfo';

// ----------------------------------------------------------------------

const LINKS = [
  {
    headline: 'IVORY Photo Studio',
    headlineAr: 'استوديو آيفوري',
    children: [
      { name: 'About us', nameAr: 'من نحن', href: paths.about },
      { name: 'Contact us', nameAr: 'تواصل معنا', href: paths.contact },
      {
        name: 'Qatar, Lusail, 25 Marina, Floor 8, Office 3',
        nameAr: 'لوسيل، ٢٥ مارينا، الطابق ٨، المكتب ٣، قطر',
        href: 'https://maps.app.goo.gl/Kt2bfk544pho1764A',
        icon: true,
      },
      // { name: 'P.O. Box : 38661 Doha, Qatar', nameAr: 'صندوق البريد : ٣٨٦٦١ الدوحة ٫ قطر' },
      // { name: 'FAQs', href: paths.faqs },
    ],
  },
  // {
  //   headline: 'Legal',
  //   children: [
  //     { name: 'Terms and Condition', href: '#' },
  //     { name: 'Privacy Policy', href: '#' },
  //   ],
  // },
  {
    headline: 'Contact',
    headlineAr: 'التواصل',
    children: [
      { name: 'info@ivory.qa', nameAr: 'info@ivory.qa', href: 'mailto:info@ivory.qa' },
      { name: '66557135', nameAr: '66557135', href: 'tel:+97466557135' },
      { name: '60093005', nameAr: '60093005', href: 'tel:+97460093005' },
    ],
  },
];

// ----------------------------------------------------------------------

export default function Footer() {
  const { isRTL } = useLocales();
  return (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        backgroundColor: 'primary.dark',
        backdropFilter: 'blur(6px)',
        color: 'common.white',
      }}
    >
      <Divider />

      <Container
        sx={{
          pt: 10,
          pb: 5,
          textAlign: { xs: 'center', md: 'unset' },
        }}
      >
        {/* <Logo sx={{ mb: 3, filter: 'brightness(0) invert(1)' }} /> */}
        <Box
          component="img"
          alt="logo"
          src="/logo/wlogo.png"
          sx={{
            height: { xs: 35, md: 45 },
            width: 'auto',
            filter: 'brightness(0) invert(1)',
          }}
        />

        <Grid
          container
          justifyContent={{
            xs: 'center',
            md: 'space-between',
          }}
        >
          <Grid xs={8} md={3}>
            <Typography
              variant="body2"
              sx={{
                maxWidth: 270,
                mx: { xs: 'auto', md: 1 },
                mt: 2,
              }}
            >
              {isRTL
                ? IVORYPhotoStudioAr.companyProfile.closingStatement
                : IVORYPhotoStudioEn.companyProfile.closingStatement}
            </Typography>

            <Stack
              direction="row"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{
                mt: 3,
                mb: { xs: 5, md: 0 },
              }}
            >
              {_socials.map((social) => (
                <IconButton
                  key={social.name}
                  sx={{
                    color: 'common.white',
                    '&:hover': {
                      bgcolor: 'primary.darker',
                    },
                  }}
                  href={social.path}
                  target="_blank"
                >
                  <Iconify icon={social.icon} />
                </IconButton>
              ))}
            </Stack>
          </Grid>

          <Grid xs={12} md={6}>
            <Stack spacing={5} direction={{ xs: 'column', md: 'row' }}>
              {LINKS.map((list) => (
                <Stack
                  key={list.headline}
                  spacing={2}
                  alignItems={{ xs: 'center', md: 'flex-start' }}
                  sx={{ width: 1 }}
                >
                  <Typography component="div" variant="overline">
                    {isRTL ? list.headlineAr : list.headline}
                  </Typography>

                  {list.children.map((link) => (
                    <Link
                      key={link.name}
                      component={RouterLink}
                      href={link.href}
                      color="inherit"
                      variant="body2"
                      target={link.icon ? '_blank' : undefined}
                      rel={link.icon ? 'noopener noreferrer' : undefined}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                      }}
                    >
                      {link.icon && <Iconify icon="mdi:map-marker" width={16} />}
                      {isRTL ? link.nameAr : link.name}
                    </Link>
                  ))}
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Typography variant="body2" sx={{ mt: 10 }}>
          IVORY Photo Studio © {new Date().getFullYear()}. All rights reserved
        </Typography>
      </Container>
    </Box>
  );
}
